import { render, staticRenderFns } from "./u-tit-default.vue?vue&type=template&id=66a0c014&scoped=true"
import script from "./u-tit-default.vue?vue&type=script&lang=js"
export * from "./u-tit-default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a0c014",
  null
  
)

export default component.exports